import { render, staticRenderFns } from "./SSelector.vue?vue&type=template&id=8983c87a&scoped=true"
import script from "./sSelector.ts?vue&type=script&lang=ts&external"
export * from "./sSelector.ts?vue&type=script&lang=ts&external"
import style0 from "./SSelector.vue?vue&type=style&index=0&id=8983c87a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8983c87a",
  null
  
)

export default component.exports